import { render, staticRenderFns } from "./orderEvaluate.vue?vue&type=template&id=bdcf66bc&scoped=true"
import script from "./orderEvaluate.vue?vue&type=script&lang=js"
export * from "./orderEvaluate.vue?vue&type=script&lang=js"
import style0 from "./orderEvaluate.vue?vue&type=style&index=0&id=bdcf66bc&prod&lang=less&scoped=true"
import style1 from "./orderEvaluate.vue?vue&type=style&index=1&id=bdcf66bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcf66bc",
  null
  
)

export default component.exports